module.exports = __webpack_public_path__ + "images/FUSA_icons/028-payment-method.b41888a5fa18f3f58e165484c5315ee6.svg";